import { render, staticRenderFns } from "./CustomBasicLayout.vue?vue&type=template&id=27ae33cb"
import script from "./CustomBasicLayout.vue?vue&type=script&lang=js"
export * from "./CustomBasicLayout.vue?vue&type=script&lang=js"
import style0 from "./CustomBasicLayout.vue?vue&type=style&index=0&id=27ae33cb&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports